import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getInsightOverview<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.DEEPDIVE.INSIGHT_OVERVIEW, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to fetch insight overview',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getInsightOverview', action: action?.type })
    }
}

export function* getAvgMetric<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.DEEPDIVE.AVG_METRIC, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to fetch average metric',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getAvgMetric', action: action?.type })
    }
}
